const e = {
  global: {
    body: {
      fontFamily: "body",
      transitionDuration: "normal",
      lineHeight: "base",
      color: "gray.800"
    },
    "*, *::before, &::after": {
      wordWrap: "break-word"
    },
    ".react-datepicker-popper": {
      zIndex: "popover"
    },
    '.react-datepicker-popper[data-placement^="bottom"]': {
      paddingTop: 2
    },
    '.react-datepicker-popper[data-placement^="top"]': {
      paddingBottom: 2
    },
    '.react-datepicker-popper[data-placement^="right"]': {
      paddingLeft: 2
    },
    '.react-datepicker-popper[data-placement^="left"]': {
      paddingRight: 2
    },
    ".react-datepicker__portal": {
      position: "fixed",
      width: "100vw",
      height: "100vh",
      background: "blackAlpha.800",
      left: 0,
      top: 0,
      justifyContent: "center",
      alignItems: "center",
      display: "flex",
      zIndex: 2147483647
    }
  }
};
export {
  e as default
};
